import { AuthScopeBase, AvengersRole, BrandDifferentiatedAuthScope, CrudOp, DifferentiationType } from "../authHelperTypes";

const CRUD = Object.values(CrudOp);
const R = [CrudOp.READ];

const brandDifferentiated = (mappings: AuthScopeBase["mappings"]): BrandDifferentiatedAuthScope => ({
  type: DifferentiationType.BRAND,
  mappings,
});

// @formatter:off
// differentiation type: BRAND
/* eslint-disable @stylistic/key-spacing */
export const configurationAuthScope = brandDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    CRUD,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  CRUD,
  [AvengersRole.TESTER]:              CRUD,
  [AvengersRole.READER]:              R,
});

export const externalConfiguratorAuthScope = brandDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.TESTER]:              CRUD,
});

export const geometryAuthScope = brandDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    CRUD,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.TESTER]:              R,
  [AvengersRole.READER]:              R,
});

export const masterSheetAuthScope = brandDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            R,
  [AvengersRole.OPERATOR_EDITORIAL]:  CRUD,
  [AvengersRole.TESTER]:              R,
  [AvengersRole.READER]:              R,
});

export const projectCreationAuthScope = brandDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
});

export const roleAssignmentAuthScope = brandDifferentiated({
  [AvengersRole.ADMIN]:               CRUD,
});

export const templateAuthScope = brandDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            R,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.TESTER]:              R,
  [AvengersRole.READER]:              R,
});
